// extracted by mini-css-extract-plugin
module.exports = {"delete":"ModalCancelButton_delete__4gNFv"};